import { AttackPattern, PatternState } from '../AttackPattern.js';

/**
 * Echo Chorus — exclusive to Riven Choir. Spawns several temporary "echo"
 * images around the boss during the telegraph, then every echo fires a
 * synchronized ring burst at once — turning a single ring pattern into a
 * many-source wall the player has to read all at once, fitting the "choir"
 * theme (many voices, one attack).
 *
 * `config` (echoCount/ringCount/damage/speed) is per-boss tuning, supplied
 * by data/bosses.js.
 */
export class EchoChorus extends AttackPattern {
  constructor({ minPhase = 2, config }) {
    super({ name: 'Echo Chorus', telegraphDuration: 0.7, activeDuration: 0.3, minPhase });
    this.config = config;
  }

  onBegin(boss) {
    const { echoCount } = this.config;
    const offsetRadius = boss.radius * 2.5;
    this._echoes = [];
    for (let i = 0; i < echoCount; i++) {
      const angle = (i / echoCount) * Math.PI * 2;
      this._echoes.push({
        x: boss.x + Math.cos(angle) * offsetRadius,
        y: boss.y + Math.sin(angle) * offsetRadius,
      });
    }
  }

  onActiveStart(_boss, _player, pool) {
    const { ringCount, damage, speed } = this.config;
    for (const echo of this._echoes) {
      for (let i = 0; i < ringCount; i++) {
        const angle = (i / ringCount) * Math.PI * 2;
        pool.fire({
          x: echo.x,
          y: echo.y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          radius: 2.5,
          damage,
          color: '#c04ae0',
          lifetime: 3,
        });
      }
    }
  }

  getVisual() {
    if (this.state === PatternState.TELEGRAPH) {
      return { kind: 'echoTelegraph', echoes: this._echoes };
    }
    return null;
  }
}
